import { CustomProperties } from "@omegagrid/core";
import { CellState } from "@reporting/rp-app-host";
import { ModuleCode } from "@reporting/rp-types/accounting";
import { AccountingOptions } from '@reporting/rp-types/core';

export const MODULES_PREFIX: Partial<Record<ModuleCode, string>> = {
    F: '',
    I: 'ITEM_',
    A: 'INVOICE_'
};

export const DIM_ORDER_TYPES = [
    {k: 'I', v: 'ID'},
    {k: 'V', v: 'name'},
];

export const DIM_VIEW_TYPES = [
    {k: 'I', v: 'ID'},
    {k: 'N', v: 'name'},
    {k: 'B', v: 'ID + name'},
];

export const ATTRIBUTE_TYPES = [
    {k: 'text', v: 'text'},
    {k: 'numeric', v: 'numeric'},
    {k: 'bool', v: 'bool'},
    {k: 'date', v: 'date'},
    {k: 'html', v: 'html'},
    {k: 'url', v: 'url'},
];

export const AGGREGATIONS = [
    {k: 'sum', v: 'sum'},
    {k: 'max', v: 'max'},
    {k: 'min', v: 'min'},
    {k: 'avg', v: 'average'},
    {k: 'cnt', v: 'count'},
    {k: 'dcnt', v: 'distinct count'},
    {k: 'median', v: 'median'},
];

export const ATTRIBUTE_PROP_NAMES: Record<string, keyof AccountingOptions> = {
    accounts: 'fin_account_attributes',
    finDetail: 'fin_text_attributes',
    itemDetail: 'item_text_attributes',
    agingDetail: 'invoice_text_attributes'
}

export const COLUMNS_PROP_NAMES: Partial<Record<ModuleCode, keyof AccountingOptions>> = {
    F: 'fin_columns',
    I: 'item_columns',
    A: 'invoice_columns'
}

export type IndicatorGroup = 'T'|'B'|'C';

export type IndicatorType = 'AMOUNT'|'QTY'|'COMP';

export type TreeGridRow = {
    cells?: TreeGridCell[],
    props?: CustomProperties,
    state?: CellState,
    index?: number,
    data?: Record<string | number, any>,
}

export type TreeGridCell = {
    c: number,
    data?: string | number,
    cProps?: CustomProperties,
    v?: unknown,
    edited?: boolean
}

export type CustomDetailProps = {
    name?: string,
    id_custom_resource?: string|number,
    id_statement?: string|number
}
